import { createFileRoute } from "@tanstack/react-router";
import { LegacyLinkRedirect } from "@/components/signin/legacy-link";

/**
 * `/reset-password/{token}` — вторая форма той же ссылки: web-роут Laravel
 * редиректил по ней на фронт старого SSO.
 *
 * Имя файла с подчёркиванием (`reset-password_.$token`) — НЕ опечатка:
 * без него роут стал бы дочерним для `/reset-password`, который своего
 * `<Outlet/>` не рисует, и переход молча не отрисовался бы вовсе
 * (`rules/code-quality.md` §18).
 */
export const Route = createFileRoute("/reset-password_/$token")({
	component: LegacyLinkRedirect,
});
